import { Injectable, Injector } from '@angular/core';

import { environment } from '@environments/environment';
import { ConfiguratorChatConfigVisbility } from '@models';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export interface GetChatConfigVisibilityParams extends DefaultHttpHeaders {}

@Injectable({
  providedIn: 'root',
})
export class ChatConfigVisibilityService extends ApiService {
  visibleInd: boolean;
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  async getChatConfigVisibility(params: GetChatConfigVisibilityParams): Promise<ConfiguratorChatConfigVisbility> {
    return this.get<ConfiguratorChatConfigVisbility>({
      suffix: '/configurator/chatConfigVisibility',
      apiUrl: environment.configuratorApiUrl,
    })
      .pipe(
        tap(data => {
          this.visibleInd = data.visibleInd ?? false;
        }),
        catchError(() => {
          this.visibleInd = false;
          return of();
        })
      )
      .toPromise();
  }
}
